import {Markdown} from '@livingdata/playground-core-front'
import './landing.css'
import './legal.css'

/* ----------------------------------------------------------------------------
   Pages légales (mentions, CGUV, politique de confidentialité). Les textes
   restent en Markdown dans src/legal/ — c'est le format de référence juridique,
   facile à relire et à mettre à jour. On les importe en `?raw` et on les rend
   ici avec le rendu markdown partagé de core-front.
   Mise en page reprise de la landing (.ld-home : paper, navy, Montserrat).
---------------------------------------------------------------------------- */

export function LegalDocument({source}: {readonly source: string}) {
  return (
    <div className='ld-home'>
      <section className='ld-section ld-section--pad'>
        <Markdown as='article' content={source} className='ld-wrap ld-legal' />
      </section>
    </div>
  )
}
